<template>
    <div class="intro">
        <title-section></title-section>
        <teaser-section></teaser-section>
    </div>
</template>

<script>
import TeaserSection from './TeaserSection.vue';
import TitleSection from './TitleSection.vue';
import MultiLingual from 'multilingual.js';

export default {
    components: {
        TeaserSection,
        TitleSection,
    },
    methods: {
        DoMultiLingual(selector) {
            new MultiLingual({
                containers: document.querySelectorAll(selector),
                configuration: ['ko', 'en', 'num', 'punct'],
            });
        },
    },
};
</script>

<style></style>
